import { Injectable } from '@angular/core';
import { TimeSeriesDataPointStatus } from '@anessa/shared-models';
import { TimeSeriesTableColumn } from '../models/timeseries-table.model';
import { parseAppNumber } from '../../../shared/number/app-number-format';

@Injectable({ providedIn: 'root' })
export class TimeSeriesValidationService {
  hasAllRequiredValues(
    columns: TimeSeriesTableColumn[],
    values: Record<string, string>,
  ): boolean {
    return columns.every(
      (column) =>
        !column.required || (values[column.key] ?? '').trim().length > 0,
    );
  }

  hasInvalidNumberValue(
    column: TimeSeriesTableColumn,
    values: Record<string, string>,
  ): boolean {
    if (column.dataType !== 'number') return false;

    const value = (values[column.key] ?? '').trim();
    if (!value) return false;

    // Locale-tolerant: accept the French comma decimal (`12,4`) by normalizing
    // before the finite check. `isValidFiniteNumber` (shared-models) stays
    // locale-neutral — we normalize here, at the frontend boundary.
    return parseAppNumber(value) === null;
  }

  hasInvalidNumberValues(
    columns: TimeSeriesTableColumn[],
    values: Record<string, string>,
  ): boolean {
    return columns.some((column) => this.hasInvalidNumberValue(column, values));
  }

  inferStatusFromValues(
    columns: TimeSeriesTableColumn[],
    values: Record<string, string>,
  ): TimeSeriesDataPointStatus {
    return this.hasAllRequiredValues(columns, values) ? 'submitted' : 'draft';
  }
}
